import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import _ from 'lodash';
import { Observable, of } from 'rxjs';
import { BASE_PATH } from '../../../generated/swagger/variables';

// Note, this service is kind of a workaround for issue https://github.com/swagger-api/swagger-codegen/issues/9836
// Todo: Onces the issue is fixed we should be able to remove it and use the UsersService directly.

@Injectable({
   providedIn: 'root',
})
export class AvatarService {
   protected basePath = '/';
   protected userAvatars = new Map<string, Observable<Blob>>();

   constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string) {
      if (basePath) {
         this.basePath = basePath;
      }
   }

   public getUserAvatar(directoryNumber: string, observe: any = 'body', reportProgress: boolean = false): Observable<Blob> {
      if (_.isEmpty(directoryNumber)) {
         return of(null);
      }

      let avatarBlob: Observable<Blob>;
      if (this.userAvatars.has(directoryNumber)) {
         avatarBlob = this.userAvatars.get(directoryNumber);
      } else {
         avatarBlob = this.httpClient.get(`${this.basePath}/api/users/avatar/${encodeURIComponent(directoryNumber)}`, {
            responseType: 'blob',
         });
         this.userAvatars.set(directoryNumber, avatarBlob);
      }

      return avatarBlob;
   }
}
